import { Link } from "react-router-dom";
import { Instagram, Mail, MapPin, Phone } from "lucide-react";
import { Wordmark, Monogram } from "@/components/Logo";
import { PLANITY_URL, GOOGLE_REVIEWS_URL, INSTAGRAM_URL, CONTACT } from "@/data/maison";

export default function Footer() {
  return (
    <footer className="bg-primary text-primary-foreground">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 py-20 grid gap-14 md:grid-cols-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-4">
            <Monogram className="w-12 h-12 text-accent" />
            <Wordmark className="text-3xl" />
          </div>
          <p className="mt-6 text-primary-foreground/70 font-light leading-relaxed max-w-sm">
            Studio privé de dermopigmentation et soins experts de la peau à
            Paris 17ᵉ. Sublimer, sans transformer.
          </p>
        </div>

        <div className="md:col-span-2">
          <p className="text-xs tracking-[0.28em] uppercase text-primary-foreground/50 mb-6">Naviguer</p>
          <ul className="space-y-3 text-sm">
            <li><Link data-testid="footer-studio-link" to="/studio" className="hover:text-accent transition-colors duration-300">Le Studio</Link></li>
            <li><Link data-testid="footer-academie-link" to="/academie" className="hover:text-accent transition-colors duration-300">L'Académie</Link></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <p className="text-xs tracking-[0.28em] uppercase text-primary-foreground/50 mb-6">La Maison</p>
          <ul className="space-y-3 text-sm text-primary-foreground/80">
            <li className="flex items-start gap-3">
              <MapPin size={16} strokeWidth={1.25} className="mt-0.5 shrink-0" />
              <span>{CONTACT.address}</span>
            </li>
            <li className="flex items-center gap-3">
              <Mail size={16} strokeWidth={1.25} className="shrink-0" />
              <a href={`mailto:${CONTACT.email}`} className="hover:text-accent transition-colors duration-300">{CONTACT.email}</a>
            </li>
            <li className="flex items-center gap-3">
              <Phone size={16} strokeWidth={1.25} className="shrink-0" />
              <a data-testid="footer-phone-link" href={`tel:${CONTACT.phoneRaw}`} className="hover:text-accent transition-colors duration-300">{CONTACT.phone}</a>
            </li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <p className="text-xs tracking-[0.28em] uppercase text-primary-foreground/50 mb-6">Suivre</p>
          <ul className="space-y-3 text-sm">
            <li>
              <a
                data-testid="footer-instagram-link"
                href={INSTAGRAM_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 hover:text-accent transition-colors duration-300"
              >
                <Instagram size={16} strokeWidth={1.25} /> Instagram
              </a>
            </li>
            <li>
              <a
                data-testid="footer-planity-link"
                href={PLANITY_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-accent transition-colors duration-300"
              >
                Réserver sur Planity
              </a>
            </li>
            <li>
              <a
                data-testid="footer-google-reviews-link"
                href={GOOGLE_REVIEWS_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-accent transition-colors duration-300"
              >
                Avis Google
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-primary-foreground/15">
        <div className="mx-auto max-w-[1400px] px-6 md:px-12 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-primary-foreground/50 tracking-wide">
          <span>© 2026 Maison Ria — Tous droits réservés</span>
          <span className="flex gap-5">
            <Link data-testid="footer-mentions-link" to="/mentions-legales" className="hover:text-accent transition-colors duration-300">Mentions légales</Link>
            <Link data-testid="footer-cgv-link" to="/cgv" className="hover:text-accent transition-colors duration-300">CGV</Link>
            <Link data-testid="footer-confidentialite-link" to="/confidentialite" className="hover:text-accent transition-colors duration-300">Confidentialité</Link>
          </span>
        </div>
      </div>
    </footer>
  );
}
